import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {config} from '../../shared/config';
import { map, tap } from 'rxjs/operators';
import {Region} from '../models/region';
import { RegionWithShape } from '../models/region-with-shape';
import { BaseHttpService } from './base-http.service';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class RegionsService extends BaseHttpService {

  private regionsData: { [key:string]: RegionWithShape } = {};

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  getRegions(): Observable<Region[]> {

    return this.get(config.generateApiUrl('Regions', null, null, '2.1')).pipe(
      map((stat) => {
        const st = stat['data'] || {data: []};
        return st as Region[];
      })
    );
  }

  getRegionData(code: string): Observable<RegionWithShape> {
    if (this.regionsData[code]) {
      return of(this.regionsData[code]);
    }
    return this.get(config.generateApiUrl(`Regions/code/${code}`, null, null, '2.2')).pipe(
      map((stat) =>  stat['data'] as RegionWithShape),
      tap((res: RegionWithShape) => this.regionsData[code] = res)
    );
  }
}
